import React from "react"
import Slider from "react-slick"
import ReactHTMLParser from "react-html-parser"
import YoutubeEmbed from "../youtube-embed/YouTubeEmbed"
import "./_timeline-container.scss"
import { generateRandomString } from "../../helpers/keys"
import useWindowWidth from "../../hooks/useWindowWidth"

export default function TimelineContainer({ contentArea, isNumbered, header, description, isVideoFormat }) {
  const timelineElements = contentArea || []
  const windowWidth = useWindowWidth()

  var settings = {
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    variableWidth: false,
  }

  if (windowWidth >= 768 && windowWidth < 920) {
    settings.slidesToShow = 2
  }

  let htmlTimeline = undefined

  //desktop HTML
  htmlTimeline =
    timelineElements.length > 0
      ? timelineElements.map((t, index) => {
          return (
            <TimelineItem
              key={generateRandomString()}
              itemNumber={index + 1}
              timelineText={ReactHTMLParser(t.timelineText)}
              image={t.timelineImage}
              youtube={t.videoId}
              isVideo={isVideoFormat}
              isNumbered={isNumbered}
            />
          )
        })
      : null

  //mobile HTML
  if (windowWidth < 768) {
    htmlTimeline = React.createElement(Slider, settings, htmlTimeline)
  }

  return (
    <section className="block-container">
      <div
        className={`timeline-container timeline-container${isNumbered ? "--ordered" : "--unordered"} ${
          isVideoFormat ? "video-format" : "image-format"
        }`}
      >
        <div className="w--normal">
          {!!header && !!description ? (
            <div className="timeline-top">
              <h3 className="">{header}</h3>
              <p className="">{description}</p>
            </div>
          ) : undefined}
          {htmlTimeline}
        </div>
      </div>
    </section>
  )
}

function TimelineItem({ timelineText, image, youtube, isVideo, itemNumber, isNumbered }) {
  return (
    <div className={`timeline-item ${isVideo ? " video-format" : " image-format"}`}>
      <article className="timeline-element">
        <div className="media-area">
          {
            //if image, show image markup
            !youtube && image ? (
              //dette scenarie skal have samme aspect ratio som video hvis isVideo er true.
              <img src={image} className={!!isVideo && !youtube && image ? "video-aspect-ratio" : ""} />
            ) : //if video, show video markup
            youtube ? (
              <YoutubeEmbed embedId={youtube} classDecleration={"timeline-video"} backgroundImage={image} />
            ) : undefined
          }
        </div>
        <div className="text-area">
          <div className="numberdot">
            <div aria-hidden="true" className="number">
              {isNumbered ? itemNumber : undefined}
            </div>
          </div>
          <div className="text-area-content">
            <div className="rich-text">{timelineText}</div>
          </div>
        </div>
      </article>
    </div>
  )
}
